import { useEffect, useState } from "react";
import { getAllPaises } from "../../../services/pais.service";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { PaisList } from "../../../modules/pais/PaisList";

export const PaisPage = () => {
  const [busqueda, setBusqueda] = useState("");
  const [paises, setPaises] = useState(null);
  const DIR_ICON_MAT = "img/iconos/titulo de docente (con la pizarra).svg";

  useEffect(() => {
    obtenerPaises();
  }, []);

  const obtenerPaises = async () => {
    await getAllPaises()
      .then((paises) => setPaises(paises))
      .catch((err) => console.log(err));
  };

  return (
    <ContenedorPageTemplate objetos={paises} dirIcono={DIR_ICON_MAT} titulo="Lista de Países">
      <div className="fila flex gap-4 justify-between items-center mb-2 w-full">
        <div className="flex flex-col justify-end items-center">
          <p className="total">
            Total de países: <span>{paises?.length || 0}</span>
          </p>
        </div>
      </div>
      <PaisList paises={paises} onRefresh={obtenerPaises} />
    </ContenedorPageTemplate>
  );
};